import { render, staticRenderFns } from "./BadgeListDefault.vue?vue&type=template&id=71774949&scoped=true&"
import script from "./BadgeListDefault.vue?vue&type=script&lang=js&"
export * from "./BadgeListDefault.vue?vue&type=script&lang=js&"
import style0 from "./BadgeListDefault.vue?vue&type=style&index=0&id=71774949&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71774949",
  null
  
)

export default component.exports